<template>
  <div class="teams-promo-wrapper">
    <Button
      @click.stop.prevent="open()"
      data-testid="invite-team-members-btn"
      class="!w-full sidebar-invite-button"
      :class="{ 'teams-promo-button-disabled': isAtUserLimit }"
      icon="general.plus"
      type="solid"
      variant="blue"
      size="medium"
      :submit="true"
    >
      Invite teammates
    </Button>
  </div>
</template>

<script lang="ts" setup>
import { useModal } from '@/storybook/modal/useModal';
import InviteModal from '../InviteModal.vue';
import { Button } from '@/storybook';
import { useUserSeats } from '@/composables/useUserSeats';
import './sidebar.css';

const { open } = useModal(InviteModal);
const { isAtUserLimit } = useUserSeats();
</script>

<style scoped>
.teams-promo-button-disabled {
  @apply opacity-50 cursor-pointer;
}

:global(.dark .button-base.solid.blue.sidebar-invite-button),
:global([data-theme='dark'] .button-base.solid.blue.sidebar-invite-button) {
  height: 44px;
  border: 0;
  border-radius: var(--radius-l);
  background: var(--blue-500);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  transition:
    background 120ms ease,
    box-shadow 120ms ease;
}

:global(.dark .button-base.solid.blue.sidebar-invite-button:hover:not(.teams-promo-button-disabled)),
:global([data-theme='dark'] .button-base.solid.blue.sidebar-invite-button:hover:not(.teams-promo-button-disabled)) {
  border: 0;
  background: var(--btn-primary-bg-hover);
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.45);
}

:global(.dark .button-base.solid.blue.sidebar-invite-button:active:not(.teams-promo-button-disabled)),
:global([data-theme='dark'] .button-base.solid.blue.sidebar-invite-button:active:not(.teams-promo-button-disabled)) {
  border: 0;
  background: var(--btn-primary-press-bg);
  box-shadow: none;
  color: var(--sidebar-rail-bg);
}

:global(.dark .button-base.solid.blue.sidebar-invite-button:focus-visible),
:global([data-theme='dark'] .button-base.solid.blue.sidebar-invite-button:focus-visible) {
  box-shadow:
    0 0 0 2px var(--sidebar-rail-bg),
    0 0 0 4px var(--focus-ring);
}

:global(.dark .button-base.solid.blue.sidebar-invite-button.teams-promo-button-disabled),
:global([data-theme='dark'] .button-base.solid.blue.sidebar-invite-button.teams-promo-button-disabled) {
  background: rgba(0, 122, 255, 0.28);
  color: rgba(255, 255, 255, 0.5);
  opacity: 1;
}
</style>
